/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { MyContext } from "../context";
import { useNavigate } from "react-router-dom";

function Error() {
  const { setErrorMsg, errorMsg } = useContext(MyContext);
  const navigate = useNavigate();

  const redirectToHome = () => {
    setErrorMsg("");
    navigate("/");
  };
  return (
    <div className="flex h-screenx">
      <div className="mr-10 mb-14 min-w-[80%]">
        <div className="py-4">
          <div className="text-centerx">
            <h2 className="text-2xl font-light leading-9 tracking-tight sm:text-4xl sm:leading-10">
              Something went wrong.
            </h2>
            <p className="mt-6 text-base leading-7 text-gray-600">
              {errorMsg || "There was an unknown error"}
            </p>
            <div className="mt-10 flex items-center gap-x-6">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => redirectToHome()}
              >
                Go back home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error;
